// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__h7RVs","labelWrapper":"Footer_labelWrapper__IiCBh","label":"Footer_label__soEiP"};